export const stroke = {
  color: '#3399CC',
}

export default {
  stroke,
}
